(function() {
    'use strict';

    angular
        .module('app.core')
        //.run(socketRunService)
        .factory('queryservice', queryservice);

    ///*@ngInject*/
    //function socketRunService(obtSocket, queryservice){
    //    if(obtSocket){
    //        obtSocket.on('disconnect', reconnectSocket);
    //    }
    //
    //    function reconnectSocket(value) { //OK
    //        value = angular.fromJson(value);
    //        queryservice.setResponseServer(value)
    //    }
    //}

    /* @ngInject */
    function queryservice($http, $state, $stateParams, $q, exception, logger, config, emitService,
                          sessionServices, obtSocket, $window, $timeout, RouterTransitionService) {
        var isPrimed = false;
        var primePromise;
        var msgId = 0;
        var callbackList = {};
        var base = config.appServiceBaseUrl;

        var is_protocal_configured = false;
        var is_protocal_error = false;
        var protocol_config = null;
        var socket_instance = null;

        var service = {
            callServer: callServer,
            ready: ready,
            getFormOptions:getFormOptions,
            findOptionNamePerId: findOptionNamePerId,
            findOptionIdPerName: findOptionIdPerName,
            findOptionCidPerId :findOptionCidPerId,
            setEvnArgs :setEvnArgs,
            setResponseServer: unWrapProtocol
        };

        return service;


        function findCurrentState(){
            var state =  RouterTransitionService.getState();
            if(state && state.name == 'stateChangeStart' && state.toState){
                return state.toState;
            }else{
                return $state.current;
            }
        }
        function prime() {
            // This function can only be called once.
            if (primePromise) {
                return primePromise;
            }

            primePromise = $q.when(true).then(success);
            return primePromise;

            function success() {
                isPrimed = true;
                logger.info('Primed data');
            }
        }

        function ready(nextPromises) {
            var readyPromise = primePromise || prime();

            return readyPromise
                .then(function() { return $q.all(nextPromises); })
                .catch(exception.catcher('"ready" function failed'));
        }

        function protocolWrapper_socket(myFctName, myArgs) {
            var currentState = findCurrentState();
            var currentSession = sessionServices.getSession() || {};
            var baseUrl = currentState.data && currentState.data.home ? $state.href(currentState.data.home, $stateParams) : '';

            var session  = {
                cId: (myArgs && myArgs.cId ? myArgs.cId : $stateParams.cId),
                tId:$stateParams.tId,
                language:$stateParams.language,
                ui: currentState.obtVid && currentState.obtPage ?  currentState.obtVid +''+ currentState.obtPage : null,
                uId:currentSession.uId,
                piwikId:protocol_config && protocol_config.piwikId ? protocol_config.piwikId : null,
                sessionId:currentSession.sessionId};
            return {
                ui: session.ui || config.ui,
                version: protocol_config && protocol_config.version ? protocol_config.version : 'obt0.1b1',
                uiOrigin: 'simpleFactory',
                sessionId: session.sessionId || null,
                piwikId: session.piwikId || null,
                retQueue: 'php',
                language: session && session.language ? session.language : config.language,
                transactionArray:[
                    {
                        commandId:'0',
                        transactionType:"1",
                        cId: session ? session.cId : null,
                        operation:1,
                        operationType:myFctName,
                        dataType:"3",
                        body:angular.toJson({
                            language: session && session.language ? session.language : config.language, //default value : fr
                            baseUrl:baseUrl,
                            ui: session.ui || config.ui,
                            cId: session ? session.cId : null,
                            uId: session ? session.uId : null,
                            fctArgsJson: myArgs,
                            php:
                            {
                                sessionId: session.sessionId || null,
                                piwikId: session.piwikId || null,
                                SERVER_HTTP_HOST: protocol_config && protocol_config.httpHost ? protocol_config.httpHost : "HOST_NOT_SET",
                                SERVER_REMOTE_ADDR: "192.168.10.1",
                                language: session && session.language ? session.language : config.language,
                                obtVersion:"/mblouin/obt-dashboard/public_html"
                            },
                            sessionId: session.sessionId || null,
                            piwikId: session.piwikId || null,
                        }),
                        error:'0'
                    }
                ],
                error:'0'
            };
        }

        function protocolWrapper(myFctName, myArgs) {
            var currentState = findCurrentState();
            var currentSession = sessionServices.getSession() || {};
            var baseUrl = currentState.data && currentState.data.home ? $state.href(currentState.data.home, $stateParams) : '';
            var session  = {
                cId: (myArgs && myArgs.cId ? myArgs.cId : $stateParams.cId),
                tId:$stateParams.tId,
                language:$stateParams.language,
                ui: currentState.obtVid && currentState.obtPage ?  currentState.obtVid +''+ currentState.obtPage : null,
                uId:currentSession.uId,
                sessionId:currentSession.sessionId,
                piwikId:protocol_config && protocol_config.piwikId ? protocol_config.piwikId : null,
            };
            return {
                operation: 'python',
                pOperation: 1,
                fctName: myFctName,
                fctArgsJson: myArgs,
                language: session && session.language ? session.language : config.language, //default value : fr
                origin: 'simpleFactory',
                baseUrl:baseUrl,
                ui: session.ui || config.ui,
                cId: session.cId || null,
                uId: session.uId || null,
                sessionId: session.sessionId || null,
                piwikId: session.piwikId || null
            };
        }
        function unWrapProtocol(protocol){
            if(protocol.data){
                protocol = protocol.data;
            }
            if (protocol.id !== null) {
                var deferred = getStoredCallBack(protocol.id);
                if (deferred) {
                    var data = protocol.transactionArray ? functionCallSanity(protocol.transactionArray[0]) : null;
                    if (data !== null) {
                        if (data.body.http === 'login') { //&&  ! data.body.sessionId){
                            deferred.reject("TIMEOUT, please re-log!");
                            handleTimeOut(data.body);
                        } else {
                            if(data.body.error === 1){
                                logger.error(data.body.body);
                                deferred.reject(data.body.body);
                            }else{
                                deferred.resolve(data.body);
                            }
                        }
                    } else {
                        if (protocol.transactionArray && protocol.transactionArray[0]
                            && protocol.transactionArray[0].body.indexOf("Error obt#48") > -1){
                            $window.location.href = './';
                        }
                        logger.error("OBT - Protocol Error - empty data!");
                        deferred.reject("OBT - Protocol Error - empty data!");
                        //$window.location.href = './';
                    }
                }
            }
//            return protocol.transactionArray ? functionCallSanity(protocol.transactionArray[0]) : null;
        }

        function functionCallSanity(protocol) {
            if (protocol) {
                if (protocol.error === 0) {
                    return {body: protocol.body, dataType: protocol.dataType};
//                  if ($scope.appState == null || !isReloginAsked(functionProtocol)) { //Check If a relogin is asked
//                  } else { //else, a relogin is asked, we must stop the current process and show the relogin dialog..
//                      //NOTE we don't return a value for this case.
//                      lauchReloginProcess();
//                  }
                } else {
                    //TODO send error msg to server
                    exception.catcher('"response" received an error flag');
                    return null;
                }
            }
            return null;
        }

        function storeCallback(obtCallback) {
            var id = msgId++;
            callbackList[id] = obtCallback;
            return id;
        }

        function getStoredCallBack(id) { /*callbackList.splice(id,1)*/
            var value = callbackList[id];
            if (value !== null) {
                delete callbackList[id];
            }
            return value;
        }

        function handleTimeOut(data) {
            exception.catcher('Timeout, please relogin');
            emitService('obt:TimeOut', data);//emit a message the msg
        }
        function sendRequest(myFctName, myArgs){
            var deferred = $q.defer();
            var msgId = storeCallback(deferred);  //Store teh Callback

            if('obtUiHelper.getUiConfig'!= myFctName && !is_protocal_configured){
                get_config_protocol()
                    .then(init_socket)
                    .then(function(){
                        sendCallServer(msgId, myFctName, myArgs);
                    });
            }else{
                sendCallServer(msgId, myFctName, myArgs);
            }

            return deferred.promise;

//            var protocol = {};
//            if(obtSocket){
//                protocol = protocolWrapper_socket(myFctName, myArgs); //create the socket protocol
//                protocol['id'] = msgId;
//                obtSocket.emit('fctCall', protocol);
//            }else{
//                protocol = protocolWrapper(myFctName, myArgs); //create the protocol
//                protocol.id = msgId;
//
//                $http.post(base + '/php/bridge.php', protocol )
//                    .then(unWrapProtocol)
//                    .catch(function(message) {
//                        var deferred = getStoredCallBack(message.id);
//                        if (deferred) {
//                            deferred.reject(message);
//                        }
//                        exception.catcher('XHR Failed for ' + myFctName )(message);
////                    $location.url('/');
//                    });
//            }
        }
        function sendCallServer(msgId, myFctName, myArgs){
            // if(myFctName == "obtAdvHelper.getFooterInfo"){
            //   var state =  RouterTransitionService.getState();
            //   console.debug({
            //     func: 'obtAdvHelper.getFooterInfo',
            //       state_name : state.name,
            //       toState : state.toState,
            //     toStateParams : state.toState.params,
            //       currentState : findCurrentState(),
            //       currentSession : sessionServices.getSession() || {},
            //
            //     language:[$stateParams.language, $state.current.params, $state.current]
            //   });
            // }

            var protocol = {};

            if(is_protocal_configured && socket_instance && obtSocket.connected()){ // Socket need to be confidured before any call
                protocol = protocolWrapper_socket(myFctName, myArgs); //create the protocol
                protocol['id'] = msgId;
                socket_instance.emit('fctCall', protocol);
            }else{
                protocol = protocolWrapper(myFctName, myArgs); //create the protocol
                protocol['id'] = msgId;
                //getQueryRessources.save(protocol, callServer_success, callServer_error);

                $http.post(base + '/php/bridge.php', protocol )
                    .then(unWrapProtocol)
                    .catch(function(message) {
                        var deferred = getStoredCallBack(message.id);
                        if (deferred) {
                            deferred.reject(message);
                        }
                        exception.catcher('XHR Failed for ' + myFctName )(message);
//                    $location.url('/');
                    });
            }
        }

        function callServer_success(value){
            unWrapProtocol(value);
        }
        function get_config_protocol(){
            return callServer('obtUiHelper.getUiConfig', {})
                .then(function(info){
                    is_protocal_configured = true;
                    protocol_config = info;
                    console.log(info,'my infos');
                    return info;
                });
        }

        function init_socket(protocol_config){
            socket_instance = obtSocket.getSocket(protocol_config.nodeJsHost , protocol_config.nodeJsPort );
            if(socket_instance){
                socket_instance.on('connect_error',
                    function(error_msg) {
                        console.info('#ERROR CONNECT SOCKET');

                        // console.log('-----------------------------------------');
                        // console.log('--------------  ERROR CONNECT SOCKET-----');
                        // console.log('-----------------------------------------');
                        //socket_instance.disconnect();
                        //socket_instance.connect();
                        //socket_instance = null;
                        //is_protocal_error = true;
                });
                //socket_instance.on('disconnect',
                //    function(error_msg) {
                //        console.log('-----------------------------------------');
                //        console.log('--------------  RECONECT SOCKET ---------');
                //        console.log('-----------------------------------------');
                //
                //        socket_instance.connect();
                //        //socket_instance = null;
                //        is_protocal_error = false;
                //});
                socket_instance.on('data', socket_callServer_success);

                //$timeout(function(){
                //    console.log('-----------------------------------------');
                //    console.log('---------  TEST DISCONNECT SOCKET -------');
                //    console.log('-----------------------------------------');
                //
                //    socket_instance.disconnect();
                //
                //}, 15000);
            }
        }
        function socket_callServer_success(value){
            value = angular.fromJson(value);
            callServer_success(value)
        }
        function callServer(myFctName, myArgs){
            return sendRequest(myFctName, myArgs)
        }


        function getFormOptions(cbIdList, cId, tId, passthrough) {
            var args = {
                cId: cId || sessionServices.getArgs('cId'),
                language: sessionServices.getArgs('language')
            };

            args.passthrough = passthrough || {};
            args.passthrough.tId = tId || sessionServices.getArgs('tId');

            if (cbIdList) {
                args['cbIdList'] = cbIdList;
            }

            if (tId) {
                args['tId'] = tId;
            }
            return callServer("obtUiHelper.getComboxBoxUpdate", args, null)
                .then(function (response) {

                    console.log(response , 'my response de getFormOPtions');
                    var options = [];

                    if (response && response.updateComboBox) {
                       _.each(response.updateComboBox, function (item) {
                           options[item.NAME] = item.COMBOVALUE;

                           //setDefault
                           _.each(item.COMBOVALUE, function findDefaultID(subItem){
                               if(subItem.ISDEFAULT){
                                   options[item.NAME + '_default'] = subItem.KEY;
                               }
                           });

                       });
                    }
                    return options;
                });
        }

        function findOptionIdPerName(nameToSearch, options, keyName, fieldName){
            //if(idToSearch){
            if(!keyName){ keyName = 'KEY'}
            if(!fieldName){fieldName = 'VALUE';}
            var fieldsToSearch = {};
            fieldsToSearch[keyName] = nameToSearch;
            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
            //}else{
            //    return null;
            //}
        }
        function findOptionNamePerId(idToSearch, options, keyName, fieldName){
            //if(idToSearch){
            if(!keyName){ keyName = 'KEY'}
            if(!fieldName){fieldName = 'VALUE';}
            var fieldsToSearch = {};
            fieldsToSearch[keyName] = idToSearch;
            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
            //}else{
            //    return null;
            //}
        }
        function findOptionCidPerId(idToSearch, options, keyName, fieldName){
            //if(idToSearch){
            if(!keyName){ keyName = 'KEY'}
            if(!fieldName){fieldName = 'CID';}
            var fieldsToSearch = {};
            fieldsToSearch[keyName] = idToSearch;
            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
            //}else{
            //    return null;
            //}
        }
        function setEvnArgs(args, cId, tId) {
            var currentSession = sessionServices.getSession();
            if (!args) {
                args = {};
            }
            if(currentSession){
                args['cId'] = cId || currentSession.cId;

                args['tId'] = tId || args.tId || currentSession.tId;
            }
        }

    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/core/query.service.js
 ** module id = 153
 ** module chunks = 0
 **/